// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"44":"692438b5486247af","831":"fe1f91552b16b29b","7399":"572160a352cb427e"}[chunkId] + ".js";
};